import { Suspense, lazy } from 'react';

const VisitForm = lazy(() => import('components/visit-form/visit-form'));

export const NewVisitorPage = (): JSX.Element => (
  <Suspense fallback={null}>
    <VisitForm />
  </Suspense>
);
